/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__costs_section__costs_details = /** @type {(inputs: {}) => string} */ () => {
	return `Einzelaufstellung der Kosten`
};

const en_route_details__costs_section__costs_details = /** @type {(inputs: {}) => string} */ () => {
	return `Cost details`
};

const es_route_details__costs_section__costs_details = /** @type {(inputs: {}) => string} */ () => {
	return `Detalle de los costes`
};

const fr_route_details__costs_section__costs_details = /** @type {(inputs: {}) => string} */ () => {
	return `Détails des coûts`
};

const it_route_details__costs_section__costs_details = /** @type {(inputs: {}) => string} */ () => {
	return `Dettaglio dei costi`
};

const nl_route_details__costs_section__costs_details = /** @type {(inputs: {}) => string} */ () => {
	return `Details van de kosten`
};

const pt_route_details__costs_section__costs_details = /** @type {(inputs: {}) => string} */ () => {
	return `Detalhes dos custos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__costs_details = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__costs_section__costs_details(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__costs_section__costs_details", locale)
	if (locale === "de") return de_route_details__costs_section__costs_details(inputs)
	if (locale === "en") return en_route_details__costs_section__costs_details(inputs)
	if (locale === "es") return es_route_details__costs_section__costs_details(inputs)
	if (locale === "fr") return fr_route_details__costs_section__costs_details(inputs)
	if (locale === "it") return it_route_details__costs_section__costs_details(inputs)
	if (locale === "nl") return nl_route_details__costs_section__costs_details(inputs)
	return pt_route_details__costs_section__costs_details(inputs)
};